/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Template_SavedInputs */

const en_us2_coaching_template_saved = /** @type {(inputs: Coaching_Template_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template saved.`)
};

const pt_br2_coaching_template_saved = /** @type {(inputs: Coaching_Template_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelo salvo.`)
};

const pt_pt2_coaching_template_saved = /** @type {(inputs: Coaching_Template_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelo salvo.`)
};

/** @type {(inputs: Coaching_Template_SavedInputs) => LocalizedString} */
const es_419_coaching_template_saved = en_us2_coaching_template_saved;

/** @type {(inputs: Coaching_Template_SavedInputs) => LocalizedString} */
const fr_fr2_coaching_template_saved = en_us2_coaching_template_saved;

/** @type {(inputs: Coaching_Template_SavedInputs) => LocalizedString} */
const de_de2_coaching_template_saved = en_us2_coaching_template_saved;

/** @type {(inputs: Coaching_Template_SavedInputs) => LocalizedString} */
const it_it2_coaching_template_saved = en_us2_coaching_template_saved;

/**
* | output |
* | --- |
* | "Template saved." |
*
* @param {Coaching_Template_SavedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_template_saved = /** @type {((inputs?: Coaching_Template_SavedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Template_SavedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_template_saved(inputs)
	if (locale === "es-419") return es_419_coaching_template_saved(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_template_saved(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_template_saved(inputs)
	if (locale === "de-DE") return de_de2_coaching_template_saved(inputs)
	if (locale === "it-IT") return it_it2_coaching_template_saved(inputs)
	return en_us2_coaching_template_saved(inputs)
});
export { coaching_template_saved as "coaching.template_saved" }